var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "32px",
    viewBox: "0 0 78 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "69B83380-4A93-4722-8011-338607243DBB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mainPage-concepts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alantm-landingame",
    transform: "translate(-401.000000, -1384.000000)",
    fill: "#FFD200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "up-arrow-2",
    transform: "translate(401.000000, 1384.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9396515,-22.2088907 C42.1744936,-23.2637031 39.6877303,-23.2637031 38.9225724,-22.2088907 C32.41873,-14.0340941 26.488756,-5.72744607 23.0455453,3.23845978 C22.6629663,4.55697535 24.7671507,5.87549092 26.488756,5.08438158 C30.3145457,3.23845978 33.5664669,0.996983318 36.4358091,-1.64004782 C35.6706512,16.8191701 32.036151,35.9376458 38.348704,54.1331607 C38.7312829,55.4516762 41.9828916,55.1879731 41.7916021,53.8692421 C38.348704,35.0144695 41.0267567,16.2915485 41.4090231,-2.56322416 C44.6609443,-0.585450806 47.9128655,1.39232254 50.9734973,3.3700959 C52.3125236,4.29305679 55.1821785,3.76565057 54.990889,2.18343188 C53.4602605,-6.51855541 49.2518919,-14.6933519 42.9396515,-22.2088907 Z M40.8354672,-6.51855541 C39.6877303,-7.70521942 36.4358091,-7.44151631 36.4358091,-5.59559452 C36.4358091,-5.46374296 36.4358091,-5.3318914 36.4358091,-5.3318914 C34.1403353,-3.74967272 32.036151,-2.16745404 29.5493877,-0.585235362 C32.6100195,-6.65040697 36.4358091,-12.3200239 40.8351547,-17.9896408 C44.6609443,-12.8474301 47.5302866,-7.57336787 49.0606024,-1.90375093 C46.9564181,-3.2222665 44.6609443,-4.54078206 42.5564474,-5.99114919 C42.1744936,-6.51855541 41.4090231,-6.65040697 40.8354672,-6.51855541 Z",
    id: "Shape",
    transform: "translate(39.000000, 16.000000) rotate(-270.000000) translate(-39.000000, -16.000000) "
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default ForwardRef;